import commonPostTypeConfig from '../../common/postTypes/review'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'review',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
